import * as dd from 'dingtalk-jsapi';

// 简化 dd api 的调用
export const isDD = dd.env.platform !== 'notInDingTalk';
export const isNotDD = !isDD;
export const isIOS = dd.env.platform === 'ios';
export const isAndroid = dd.env.platform === 'android';

const nav = dd.biz.navigation;
const noop = () => {};

// 设置标题
export const setTitle = (title, onSuccess = noop, onFail = noop) => {
  if (isDD) {
    nav.setTitle({
      title,
      onSuccess,
      onFail,
    });
  } else {
    document.title = title;
  }
};

export const setRight = (options) => {
  if (isDD) {
    // 因为同时设置标题和右上角内容，会莫名失败
    setTimeout(() => {
      nav.setRight(options);
    }, 300);
  }
};
export const setLeft = (options) => {
  if (isDD) {
    // 因为同时设置标题和右上角内容，会莫名失败
    setTimeout(() => {
      nav.setLeft(options);
    }, 300);
  }
};

export const setMenu = (options) => {
  if (isDD) {
    dd.ready(() => {
      nav.setMenu(options);
    });
  }
};
export const toast = (text) => {
  console.log(text);
  if (isDD) {
    dd.device.notification.toast({
      text, // 提示信息
      duration: 2, // 显示持续时间，单位秒，默认按系统规范[android只有两种(<=2s >2s)]
    });
  }
};
dd.error((e) => {
  console.log('dd.js dd error:', e);
});
